var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "d-flex flex-wrap align-items-center nav_wrapper"
  }, [_vm._l(_vm.tabs, function (tab, tabIdx) {
    return _c('div', {
      key: tabIdx,
      staticClass: "tabButton",
      class: {
        active: _vm.selectedTab === tab
      },
      on: {
        "click": function click($event) {
          return _vm.setSelectedTab(tab);
        }
      }
    }, [_vm._v(" " + _vm._s(tab) + " ")]);
  }), _c('div', {
    staticClass: "ml-auto siteSelect"
  }, [_c('v-autocomplete', {
    staticClass: "textInput",
    attrs: {
      "items": _vm.getFieldNameList,
      "outlined": "",
      "attach": "",
      "dense": "",
      "hide-details": "",
      "color": "energy_blue",
      "item-color": "energy_blue",
      "menu-props": {
        offsetY: true
      },
      "placeholder": "選擇案場"
    },
    on: {
      "change": _vm.handleChangeSite
    },
    model: {
      value: _vm.selectedFieldName,
      callback: function callback($$v) {
        _vm.selectedFieldName = $$v;
      },
      expression: "selectedFieldName"
    }
  })], 1)], 2), _c('div', {
    staticClass: "d-flex align-items-baseline"
  }, [_c('div', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.right.html",
      value: {
        title: _vm.titleTooltip
      },
      expression: "{ title: titleTooltip }",
      modifiers: {
        "hover": true,
        "right": true,
        "html": true
      }
    }],
    staticClass: "text_title pr-5",
    class: [_vm.titleTooltip ? 'cursor-pointer' : 'cursor-default']
  }, [_vm._v(" " + _vm._s(_vm.selectedFieldName) + " ")]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.selectedTab === '用電',
      expression: "selectedTab === '用電'"
    }],
    staticClass: "text_update ml-auto"
  }, [_vm._v(" 最後更新 " + _vm._s(_vm.lastUpdateTime) + " ")])]), _c('keep-alive', [_c(_vm.currentTabComponent, {
    tag: "component",
    attrs: {
      "selected-field-name": _vm.selectedFieldName
    }
  })], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };